import { ProfileResume } from './ProfileResume';
import { ProfileRating } from './ProfileRating';
import { ProfileRecomendations } from './ProfileRecomendations';
import { ProfileServices } from './ProfileServices';
import { ProfileCertification } from './ProfileCertification';

export {
  ProfileResume,
  ProfileRating,
  ProfileRecomendations,
  ProfileServices,
  ProfileCertification,
};
